import { render, staticRenderFns } from "./MPrice.vue?vue&type=template&id=5a1ef4c4&scoped=true"
import script from "./MPrice.vue?vue&type=script&lang=js"
export * from "./MPrice.vue?vue&type=script&lang=js"
import style0 from "./MPrice.vue?vue&type=style&index=0&id=5a1ef4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ef4c4",
  null
  
)

export default component.exports